import { logD } from "@blacknut/logging/dist";
import * as H from "history";
import { createMemoryHistory, LocationState } from "history";
import React from "react";
import { Router } from "react-router";
import { To } from "react-router-dom-v5-compat";
const LOGGING_TAG = "Navigation";
const MAX_DEPTH = 5;
const LEVEL_1 = ["/plus", "/myList", "/browse", "search"];

const isLevel1 = (to: To) => {
  const pathname = typeof to === "string" ? to : to.pathname;
  return !!LEVEL_1.find((path) => {
    const re = new RegExp(path);
    return pathname?.match(re);
  });
};

const createCatalogEntry = (): H.Location<unknown> => {
  return {
    pathname: "/catalog",
    state: undefined,
    search: "",
    hash: "",
    key: "default",
  };
};

export const createCustomHistory = () => {
  const history = createMemoryHistory({
    initialEntries: [window.location],
  });
  const originalPush = history.push;
  const originalGo = history.go;

  history.go = (n: number) => {
    originalGo(n);
    // Prune history
    history.entries = history.entries.slice(0, history.index + 1);
    history.length = history.entries.length;
  };

  history.push = (location: H.Location, state?: LocationState): void => {
    const pathname = location.pathname;
    if (pathname.match(/\/welcome/) || pathname.match(/\/catalog/)) {
      logD(LOGGING_TAG, "Reset memory history");
      history.entries = [];
    } else if (isLevel1(pathname)) {
      logD(LOGGING_TAG, "Navigate to level 1 (%o)", pathname);
      history.entries = [createCatalogEntry()];
    } else if (history.length >= MAX_DEPTH) {
      const oldEntries = history.entries;
      const sliced = oldEntries.slice(-MAX_DEPTH + 1);
      const newEntries: H.Location<unknown>[] = [createCatalogEntry(), ...sliced];
      logD(LOGGING_TAG, "Push new entry (%o). History: %o", pathname, newEntries);
      history.entries = newEntries;
    }
    history.index = history.entries.length - 1;
    history.length = history.entries.length;
    originalPush(location, state);
  };

  return history;
};

export class TVRouter extends React.Component<unknown, { time: number }> {
  static history: H.MemoryHistory<unknown>;

  constructor(props: unknown) {
    super(props);
    this.state = { time: 0 };

    TVRouter.history = createCustomHistory();
  }
  render(): React.ReactNode {
    return <Router history={TVRouter.history}>{this.props.children}</Router>;
  }

  update() {
    this.setState({ time: new Date().getTime() });
  }
}
